
export default {
    DELETE_CANVAS_OBJECT: "DELETE_CANVAS_OBJECT",
    CREATE_CANVAS_OBJECT: "CREATE_CANVAS_OBJECT",
    UPDATE_CANVAS_OBJECT: "UPDATE_CANVAS_OBJECT",
    SET_ACTIVE_OBJECT: "SET_ACTIVE_OBJECT"
}

export const CANVAS_OBJECT_TYPES = {
    TEXT: "TEXT",
    IMAGE: "IMAGE"
}